import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class UriService {
  private base62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  public generateUri(length: number = 15): string {
    let sb = '';
    for (let i = 0; i < length; i++) {
      sb += this.base62.charAt(Math.random() * 62);
    }
    return sb;
  }

  public generateUuid(): string {
    return uuidv4();
  }
}
